"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifySignatureResponse = void 0;
const ton_1 = require("ton");
const extractPublicKeyAndAddress_1 = require("../contracts/extractPublicKeyAndAddress");
function verifySignatureResponse(args) {
    // Check address
    const address = ton_1.Address.parseFriendly(args.config.address).address;
    // Extract public key and address
    let extracted = (0, extractPublicKeyAndAddress_1.extractPublicKeyAndAddress)(args.config);
    if (!extracted) {
        return false;
    }
    // Check address
    if (!extracted.address.equals(address)) {
        return false;
    }
    let publicKey = extracted.publicKey;
    // Package
    let textCell = new ton_1.Cell();
    let payloadCell = new ton_1.Cell();
    if (typeof args.text === 'string') {
        new ton_1.CommentMessage(args.text).writeTo(textCell);
    }
    if (typeof args.payload === 'string') {
        payloadCell = ton_1.Cell.fromBoc(Buffer.from(args.payload, 'base64'))[0];
    }
    // Check signature
    const data = (0, ton_1.beginCell)()
        .storeRef(textCell)
        .storeRef(payloadCell)
        .endCell();
    const signed = (0, ton_1.safeSignVerify)(data, Buffer.from(args.signature, 'base64'), publicKey);
    return signed;
}
exports.verifySignatureResponse = verifySignatureResponse;
